module.exports = __webpack_public_path__ + "img/support_a9.a1431a15.png";